import React from "react";

function RegisterInterestStep2({ surveyData, onChange, onSubmit, disabled }) {
  return (
<>
      <p>
        If you have a moment we would appreciate if you would fill out this quick survey to help us gauge audience 
        and logistics for the conference. Thank you.
      </p>
    <form onSubmit={onSubmit} className="conference-form">
      <h3>Conference Survey</h3>
            <div>
        <span>Which dates are you intending to attend?</span>        
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="dates" 
              value="15th June"
              checked={surveyData.dates.includes("15th June")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">15th June - Tannery & Farm tours + social evening with food at the local micro-brewery bar</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="dates" 
              value="16th June"
              checked={surveyData.dates.includes("16th June")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">16th June - Conference Programme + Informal evening dinner on site</span>
          </label>                    
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="dates" 
              value="17th June"
              checked={surveyData.dates.includes("17th June")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">17th June - Conference Programme</span>
          </label>

        </div>
      </div>

      <div>
        <label>What accommodation would you likely use</label>
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="accommodation" 
              value="Hotel"
              checked={surveyData.accommodation === "Hotel"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Hotel</span>
          </label>

          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="accommodation" 
              value="Camping"
              checked={surveyData.accommodation === "Camping"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Camping</span>
          </label>

          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="accommodation" 
              value="Hire bell tent"
              checked={surveyData.accommodation === "Hire bell tent"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Hire bell tent</span>
          </label>

          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="accommodation" 
              value="Other"
              checked={surveyData.accommodation === "Other"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Other</span>
          </label>

          {surveyData.accommodation === "Other" && (
            <input
              type="text"
              id="otherAccommodation"
              name="otherAccommodation"
              value={surveyData.other.accommodation}
              onChange={onChange}
              required
            />
          )}

        </div>
      </div>

      <div>
        <label>What is your interest in the conference?</label>
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Tanner"
              checked={surveyData.interest === "Tanner"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Tanner</span>
          </label>                    
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Interested in becoming a tanner"
              checked={surveyData.interest === "Interested in becoming a tanner"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Interested in becoming a tanner</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Leather maker"
              checked={surveyData.interest === "Leather maker"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Leather maker</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Industry professional"
              checked={surveyData.interest === "Industry professional"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Industry professional</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Leather enthusiast"
              checked={surveyData.interest === "Leather enthusiast"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Leather enthusiast</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="radio" 
              name="interest" 
              value="Other"
              checked={surveyData.interest === "Other"}
              onChange={onChange}
            />
            <span className="custom-radio"></span>
            <span className="line-height-1">Other</span>
          </label>
          {surveyData.interest === "Other" && (
            <input
              type="text"
              id="otherInterest"
              name="otherInterest"
              value={surveyData.other.interest || ""}
              onChange={onChange}
              required
            />
          )}
        </div>
      </div>
             
      <div>
        <label>What type of leather are you interested in, check all that apply</label>
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Cattle"
              checked={surveyData.leather.includes("Cattle")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Cattle</span>
          </label>
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Deer"
              checked={surveyData.leather.includes("Deer")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Deer</span>
          </label>                    
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Goat"
              checked={surveyData.leather.includes("Goat")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Goat</span>
          </label>                    
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Sheep"
              checked={surveyData.leather.includes("Sheep")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Sheep</span>
          </label>                            
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Fish"
              checked={surveyData.leather.includes("Fish")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Fish</span>
          </label>          
          <label className="checkbox-container margin-b-20">
            <input 
              type="checkbox" 
              name="leather" 
              value="Other"
              checked={surveyData.leather.includes("Other")}
              onChange={onChange}
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Other</span>
          </label>
          {surveyData.leather.includes("Other") && (
            <input
              type="text"
              id="otherLeather"
              name="otherLeather"
              value={surveyData.other.leather || ""}
              onChange={onChange}
              // onChange={surveyData.leather.includes("Goat"),onChange}
              required
            />
          )}

        </div>
      </div>
      <div>
        <button type="submit" className="primary" disabled={disabled}>
          Submit Survey
        </button>
      </div>
    </form>
    </>
  );
}

export default RegisterInterestStep2;